import './Button.css';

const Button = ({ text, id, classes, onClickHandler, href }) => {
    return(
      <div 
        className={`btn ${classes}`} 
        id={id} 
        onClick={onClickHandler} 
        data-testid="btn">
        {
          href
            ? <a href={href} target="_top" className={`a ${classes}`} data-testid="a">{text}</a>
            : text
        }
      </div>
    );
}

export default Button;